"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionBlock = void 0;
/*
    Defines which block (aka page) of the in-app survey is currently being displayed
*/
var QuestionBlock;
(function (QuestionBlock) {
    QuestionBlock[QuestionBlock["PreSurvey"] = 0] = "PreSurvey";
    QuestionBlock[QuestionBlock["Intercept"] = 1] = "Intercept";
    QuestionBlock[QuestionBlock["Other"] = 2] = "Other";
})(QuestionBlock = exports.QuestionBlock || (exports.QuestionBlock = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RhbnRzL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBOztFQUVFO0FBQ0YsSUFBWSxhQUlYO0FBSkQsV0FBWSxhQUFhO0lBQ3JCLDJEQUFTLENBQUE7SUFDVCwyREFBUyxDQUFBO0lBQ1QsbURBQUssQ0FBQTtBQUNULENBQUMsRUFKVyxhQUFhLEdBQWIscUJBQWEsS0FBYixxQkFBYSxRQUl4QiJ9